import { ShieldAlert, Phone } from "lucide-react";
import { PageHero, SectionHead } from "../components/site/PageHero";
import { Reveal } from "../components/site/Reveal";
import { CaseForm } from "../components/forms/CaseForm";
import { LEGAL_CATEGORIES, LEGAL_SERVICES, ORG, RIGHTS_DISCLAIMER } from "../data/content";

export default function LegalSupport() {
  return (
    <>
      <PageHero eyebrow="Legal Support" title="Legal Support & Assistance" subtitle="Guidance on employment disputes, labour department procedures and referrals to qualified legal professionals." image="/images/houseboat.jpg" testId="legal-hero" />
      <section className="py-16 md:py-24">
        <div className="container-x">
          <SectionHead eyebrow="How we help" title="Areas of legal support" />
          <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {LEGAL_SERVICES.map(({ icon: Icon, title, text }, i) => (
              <Reveal key={title} delay={i * 0.05}>
                <div className="card-lift h-full rounded-xl border border-slate-200 bg-white p-7" data-testid={`legal-service-${i}`}>
                  <Icon className="h-7 w-7 text-royal" />
                  <h3 className="mt-5 font-display text-lg font-bold text-navy">{title}</h3>
                  <p className="mt-2 text-sm text-slate-600">{text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      <section id="request" className="scroll-mt-28 bg-slate-100/70 py-16 md:py-24">
        <div className="container-x grid gap-10 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <SectionHead eyebrow="Request Legal Assistance" title="Tell us about your situation" text="Share the details of your issue. The federation office will review the request and get in touch." />
            <a href={`tel:+91${ORG.phone}`} className="mt-6 flex items-center gap-3 rounded-xl bg-navy p-5 text-white" data-testid="legal-call-link">
              <Phone className="h-5 w-5 text-emerald-300" /><span><span className="block text-xs text-slate-400">Call the office</span>{ORG.phoneDisplay}</span>
            </a>
            <p className="mt-6 flex items-start gap-2 text-xs text-slate-500"><ShieldAlert className="h-4 w-4 shrink-0" />{RIGHTS_DISCLAIMER}</p>
          </div>
          <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm sm:p-8 lg:col-span-8">
            <CaseForm kind="legal" categories={LEGAL_CATEGORIES} submitLabel="REQUEST LEGAL ASSISTANCE" />
          </div>
        </div>
      </section>
    </>
  );
}
